<div class="newsletter-container loading" *ngIf="loading">
  <app-spinner></app-spinner>
</div>
<div class="newsletter-container" *ngIf="!loading">
  <ng-container *ngIf="!success">
    <ng-container *ngIf="!isSubmitting">

      <app-form #form [handler]="this" (submit)="submit()" class="form-fields">
        <error-message [producer]="this"></error-message>
        <ng-container *ngIf="validFormCheck()">
          <div *ngIf="inputFields['email']" class="form-group text-field">
            <input 
              type="email" 
              name="email" 
              [(ngModel)]="email" 
              required
              placeholder="Enter your email address" 
              errorHighlight 
              class="form-control" 
              autocomplete="email"
              >
          </div>

          <div *ngIf="inputFields['first_name']" class="form-group text-field">
            <input 
              type="text" 
              name="firstname"
              [(ngModel)]="firstname" 
              required
              placeholder="First Name" 
              errorHighlight 
              class="form-control" 
              autocomplete="given-name"
              />
          </div>

          <div *ngIf="inputFields['last_name']" class="form-group text-field">
            <input 
              type="text" 
              name="lastname"
              [(ngModel)]="lastname" 
              required
              placeholder="Last Name" 
              errorHighlight 
              class="form-control" 
              autocomplete="family-name"
              />
          </div>

          <div *ngIf="inputFields['phone']" class="form-group text-field">
            <input 
              type="tel"
              name="phonenumber"
              class="form-control"
              [(ngModel)]="phonenumber" 
              required
              placeholder="Phone Number" 
              errorHighlight
              autocomplete="tel"
              />
          </div>

          <div *ngIf="showCheckBoxes" class="checkboxes-group">
            <div class="description" *ngIf="checkboxDescription">{{checkboxDescription}}</div>
            
            <ng-container *ngFor="let pref of emailPrefs" class="checkbox-label">
              <label *ngIf="newsletterTypesForDisplay[pref.provider_id]">
                <input type="checkbox" [(ngModel)]="pref.allowed" [name]="pref.provider_id">
                {{pref.label}}
              </label>
            </ng-container>
          </div>

          <br/>
          <button class="submit-btn" [disabled]="!isValid">{{submitText}}</button>
        </ng-container>

        <ng-container *ngIf="!validFormCheck()">
          <p class="center">Uh oh, looks like there's a problem with this form! Please let us know by contacting
            support@tytnetwork.com</p>
        </ng-container>
      </app-form>
    </ng-container>

    <div class="spinner-holder" *ngIf="isSubmitting">
        <app-spinner></app-spinner>
    </div>
  </ng-container>
  <ng-container *ngIf="success">
    <div class="success">
      <img src="/assets/icons-2019/newsletters.svg" alt="Newsletter icon" />
      <h1>Success!</h1>
      <p>Thank you for subscribing!</p>
      <p>Now just make sure our email addresses are in your safe senders list so your newsletters don't get sent to spam or promotions, and we'll see you in the next edition!</p>
      <ul>
        <li *ngIf="checkedNewsletters.includes('shop')">orders@tytnetwork.com</li>
        <li *ngIf="checkedNewsletters.includes('newsletter')">tytnetwork@tytnetwork.com</li>
      </ul>
    </div>
  </ng-container>
</div>
